import { GrowthBook } from "@growthbook/growthbook";
import analyticsPlugin from "../../utils/eventAnalytics/plugin";

let gb = null

// Cache UTM parameters once on module load (URL won't change after initial load)
const urlParams = new URLSearchParams(window.location.search)
const cachedUtmParams = {
  source: urlParams.get('utm_source') || null,
  medium: urlParams.get('utm_medium') || null,
  campaign: urlParams.get('utm_campaign') || null
}

const state = {
  isInitialized: false,
  userAttributes: {}
}

const mutations = {
  SET_INITIALIZED (state, status) {
    state.isInitialized = status
  },
  SET_USER_ATTRIBUTES (state, attributes) {
    state.userAttributes = attributes
  }
}

const actions = {
  async initializeGrowthBook ({ commit }, config = {}) {
    try {
      const defaultConfig = {
        apiHost: window.GROWTHBOOK_API_URL,
        clientKey: window.GROWTHBOOK_CLIENT_KEY,
        trackingCallback: (experiment, result) => {
          analyticsPlugin.experiment.experimentSeen({
            experimentId: experiment.key,
            variationId: result.key,
            experimentName: experiment.name || experiment.key,
            variationName: result.name || result.key,
            browser: navigator.userAgent,
            utmSource: cachedUtmParams.source,
            utmMedium: cachedUtmParams.medium,
            utmCampaign: cachedUtmParams.campaign
          });
        },
        enableDevMode: true
      }

      const finalConfig = Object.assign({}, defaultConfig, config)

      gb = new GrowthBook(finalConfig)

      await gb.loadFeatures()

      commit('SET_INITIALIZED', true)

      return gb
    } catch (error) {
      console.error('Failed to initialize GrowthBook:', error)
      throw error
    }
  },

  async updateUserAttributes ({ commit }, user = null) {
    if (!gb) {
      console.log('GrowthBook not initialized')
      return
    }

    try {
      const currentAttributes = gb.getAttributes()
      const newUserId = user && user.id ? user.id.toString() : null

      if (currentAttributes.id !== newUserId) {
        // Set all attributes together to avoid multiple calls
        gb.setAttributes({
          id: newUserId,
          browser: navigator.userAgent,
          utmSource: cachedUtmParams.source,
          utmMedium: cachedUtmParams.medium,
          utmCampaign: cachedUtmParams.campaign
        })

        const updatedAttributes = gb.getAttributes()
        commit('SET_USER_ATTRIBUTES', updatedAttributes)
      }
    } catch (error) {
      console.error('Failed to update GrowthBook user attributes:', error)
      throw error
    }
  }
}

const getters = {
  isGrowthBookInitialized: state => state.isInitialized,
  getGrowthBookInstance: () => gb,
  getFeature: () => (key) => {
    if (!gb) return null
    return gb.feature(key)
  },
  getUserAttributes: state => state.userAttributes
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
